import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
// context
import { useAdmin } from "../../context/admin"
// components
import Navbar from "../../components/admin/Navbar"
import background from '../../assets/admin/background.jpg'
import Sidebar from "../../components/admin/Sidebar"
// modals
import CreateTour from "../../components/admin/superowner/modals/CreateTour"
import TourInfo from "../../components/admin/modals/TourInfo"
import CreatePassenger from "../../components/admin/modals/CreatePassenger"
import CreateAgency from "../../components/admin/superowner/modals/CreateAgency"
import CreateSeller from "../../components/admin/modals/CreateSeller"
import CreateAdmin from "../../components/admin/modals/CreateAdmin"
import CreateCar from "../../components/admin/modals/CreateCar"
import CreateCost from "../../components/admin/modals/CreateCost"
import PassengerPlan from "../../components/admin/modals/PassengerPlan"
import CreateGuider from "../../components/admin/modals/CreateGuider"
import CreateDriver from "../../components/admin/modals/CreateDriver"
import EditTrip from "../../components/admin/modals/EditTrip"
import AgencyRelationship from "../../components/admin/modals/AgencyRelationship"
import EditReservation from "../../components/admin/modals/EditReservation"
import EditPassenger from "../../components/admin/modals/EditPassenger"
import AssignRservation from "../../components/admin/modals/AssignReservation"
import TraspassReservation from "../../components/admin/modals/TraspassReservation"
import ReadExcel from "../../components/admin/modals/ReadExcel"
import RegisterCosts from "../../components/admin/modals/RegisterCosts"
import Requirements from "../../components/admin/modals/Requirements"
import Accounting from "../../components/admin/modals/Accounting"
import AddPayment from "../../components/admin/modals/AddPayment"
import EditTour from "../../components/admin/superowner/modals/EditTour"
import GroupDetails from "../../components/admin/modals/GroupDetails"
import ListBlogs from "../../components/admin/modals/ListBlogs"
import CreateZone from "../../components/admin/modals/CreateZone"
import EditZone from "../../components/admin/modals/EditZone"
import CreateSubzone from "../../components/admin/modals/CreateSubzone"
import EditSubzone from "../../components/admin/modals/EditSubzone"
import ReservationsDetails from "../../components/admin/modals/ReservationsDetails"
import ViewPayments from "../../components/admin/modals/ViewPayments"
import CreatePaymentReservation from "../../components/admin/modals/CreatePaymentReservation"
import CreateMultiPaymentReservation from "../../components/admin/modals/CreateMultiPaymentReservation"
import EditTourInfo from "../../components/admin/modals/EditTourInfo"
import PostBlog from "../../components/admin/modals/PostBlog"
import EditDriver from "../../components/admin/modals/EditDriver"
import EditCar from "../../components/admin/modals/EditCar"
import EditGuider from "../../components/admin/modals/EditGuider"
import EditSeller from "../../components/admin/modals/EditSeller"
import EditAdmin from "../../components/admin/modals/EditAdmin"
import EditAgency from "../../components/admin/superowner/modals/EditAgency"
import EditCost from "../../components/admin/modals/EditCost"
import EditPayment from "../../components/admin/modals/EditPayment"
import EditPassengerReservation from "../../components/admin/modals/EditPassengerReservation"
import EditBlog from "../../components/admin/modals/EditBlog"
import ConfirmDeleteTour from "../../components/admin/superowner/modals/ConfirmDeleteTour"
import ConfirmDeleteAgency from "../../components/admin/superowner/modals/ConfirmDeleteAgency"
import ConfirmDeleteCar from "../../components/admin/modals/confirmation/ConfirmDeleteCar"
import ConfirmDeleteTrip from "../../components/admin/modals/confirmation/ConfirmDeleteTrip"
import ConfirmDeleteReservation from "../../components/admin/modals/confirmation/ConfirmDeleteReservation"
import ConfirmUnassignReservation from "../../components/admin/modals/confirmation/ConfirmUnassignReservation"
import ConfirmDeleteCost from "../../components/admin/modals/confirmation/ConfirmDeleteCost"
import ConfirmDeletePayment from "../../components/admin/modals/confirmation/ConfirmDeletePayment"
import CreatePayment from "../../components/admin/modals/CreatePayment"
import ViewReservationData from "../../components/admin/modals/ViewReservationData"
import ViewPaymentsReservation from "../../components/admin/modals/ViewPaymentsReservations"
import EditPaymentReservation from "../../components/admin/modals/EditPaymentReservation"
import CreateDailyCost from "../../components/admin/modals/CreateDailyCost"
import ListDailyCosts from "../../components/admin/modals/ListDailyCosts"
import EditDailyCost from "../../components/admin/modals/EditDailyCost"
import ViewPaymentsTraspass from "../../components/admin/modals/ViewPaymentsTraspass"
import ConfirmDeletePassenger from "../../components/admin/modals/confirmation/ConfirmDeletePassenger"
import RegisterReTraspaso from "../../components/admin/modals/RegisterReTraspaso"
import CreatePaymentReTraspaso from "../../components/admin/modals/CreatePaymentReTraspaso"
import CreateRevision from "../../components/admin/modals/CreateRevision"
import EditTraspassAmount from "../../components/admin/modals/EditTraspassAmount"
import CreateCashMovement from "../../components/admin/modals/CreateCashMovement"
import EditCashMovement from "../../components/admin/modals/EditCashMovement"
import ConfirmDeleteCashMovement from "../../components/admin/modals/confirmation/ConfirmDeleteCashMovement"
import CreatePendingPayment from "../../components/admin/modals/CreatePendingPayment"
import EditPendingPayment from "../../components/admin/modals/EditPendingPayment"
import ConfirmDeletePendingPayment from "../../components/admin/modals/confirmation/ConfirmDeletePendingPayment"
import CreateAlly from "../../components/admin/modals/CreateAlly"
import AllyInfo from "../../components/admin/modals/AllyInfo"
// tabs
import Passengers from "../../components/admin/Passengers"
import Tours from "../../components/admin/Tours"
import Agencies from "../../components/admin/superowner/Agencies"
import Sellers from "../../components/admin/Sellers"
import Admins from "../../components/admin/Admins"
import Me from "../../components/admin/Me"
import Guiders from "../../components/admin/Guiders"
import Drivers from "../../components/admin/Drivers"
import Reservations from "../../components/admin/Reservations"
import Trips from "../../components/admin/Trips"
import Traspass from "../../components/admin/Traspass"
import Earnings from "../../components/admin/Earnings"
import Zones from "../../components/admin/Zones"
import Sales from "../../components/admin/Sales"
import Cars from "../../components/admin/Cars"
import Costs from "../../components/admin/Costs"
import Authorizations from "../../components/admin/Authorizations"
import Bot from "../../components/admin/Bot"
import Caja from "../../components/admin/Caja"
import Shifts from "../../components/admin/Shifts"
import Allies from "../../components/admin/Allies"
// responsive
import { mobile } from "../../styles/responsive"

export default function Home() {
    const { 
        tab, 
        isCreateTourModalOpen, 
        isCreatePassengerModalOpen, 
        isCreateSellerModalOpen,
        isCreateAdminModalOpen,
        isCreateAgencyModalOpen,
        isCreateGuiderModalOpen,
        isCreateDriverModalOpen,
        tourInfoId, 
        passengerPlanId,
        traspassTripReservationId,
        assignTripReservationId,
        registerPassengersTripId,
        registerCostsTripId,
        requirementsTripId,
        accountingSellerId,
        editTripId,
        relationshipAgencyId,
        editReservationId,
        editPassengerData,
        editTourData,
        editDriverData,
        editGuiderData,
        editSellerData,
        editAdminData,
        editAgencyData,
        addPaymentData,
        reservationDetails,
        viewPaymentAgencyId,
        editTourInfoId,
        createBlogTourId,
        isCreateZoneModalOpen,
        editZoneId,
        groupDetails,
        isCreateSubzoneModalOpen,
        editSubzoneId,
        user,
        listBlogsTourId,
        editBlog,
        confirmDeleteTourId,
        confirmDeleteAgencyId,
        isCreateCarModalOpen,
        editCarData,
        confirmDeleteCarId,
        confirmDeleteTripId,
        confirmDeleteReservationId,
        confirmUnassignReservationId,
        editPassengerReservationId,
        createPaymentReservationId,
        isCreateCostModalOpen,
        editCostData,
        confirmDeleteCostId,
        editPaymentData,
        confirmDeletePaymentId,
        createPaymentResId,
        viewPaymentsData,
        reservationData,
        isCreatePaymentReservationModalOpen,
        editPaymentReservationData,
        isCreateDailyCostModalOpen,
        isListDailyCostsModalOpen,
        editDailyCostData,
        viewPaymentTraspassData,
        confirmDeletePassengerId,
        createPaymentGroupId,
        isCreateReTraspasoModalOpen,
        createPaymentReTraspasoData,
        createRevisionData,
        editTraspassAmountReservationId,
        isCreateCashMovementModalOpen,
        editCashMovementData,
        confirmDeleteCashMovementId,
        isCreatePendingPaymentModalOpen,
        createMultiPaymentReservations,
        editPendingPaymentData,
        confirmDeletePendingPaymentId,
        isCreateAllyModalOpen,
        allyInfoId
    } = useAdmin()
    const router = useNavigate()
    
    useEffect(() => {
        if (!user) router('/admin/access')
    },  [user, router])

    return (
        <Main>
            <Modal>
                <Sidebar/>
                <Content>
                    <Navbar/>
                    {
                        tab === 'tours' &&
                        <Tours/>
                    }
                    {
                        tab === 'passengers' &&
                        <Passengers/>
                    }
                    {
                        tab === 'agencies' && user?.user.source === 'superowners' &&
                        <Agencies/>
                    }
                    {
                        tab === 'sellers' &&
                        <Sellers/>
                    }
                    {
                        tab === 'admins' &&
                        <Admins/>
                    }
                    {
                        tab === 'me' &&
                        <Me/>
                    }
                    {
                        tab === 'guiders' &&
                        <Guiders/>
                    }
                    {
                        tab === 'drivers' &&
                        <Drivers/>
                    }
                    {
                        tab === 'reservations' &&
                        <Reservations/>
                    }
                    {
                        tab === 'trips' &&
                        <Trips/>
                    }
                    {
                        tab === 'authorizations' &&
                        <Authorizations/>
                    }
                    {
                        tab === 'traspass' &&
                        <Traspass/>
                    }
                    {
                        tab === 'earnings' &&
                        <Earnings/>
                    }
                    {
                        tab === 'zones' &&
                        <Zones/>
                    }
                    {
                        tab === 'sales' &&
                        <Sales/>
                    }
                    {
                        tab === 'cars' &&
                        <Cars/>
                    }
                    {
                        tab === 'costs' &&
                        <Costs/>
                    }
                    {
                        tab === 'bot' &&
                        <Bot/>
                    }
                    {
                        tab === 'caja' &&
                        <Caja/>
                    }
                    {
                        tab === 'turnos' &&
                        <Shifts/>
                    }
                    {
                        tab === 'allies' &&
                        <Allies/>
                    }
                </Content>
            </Modal>
            {
                isCreateTourModalOpen &&
                <CreateTour/>
            }
            {
                tourInfoId &&
                <TourInfo/>
            }
            {
                isCreatePassengerModalOpen &&
                <CreatePassenger/>
            }
            {
                isCreateAgencyModalOpen &&
                <CreateAgency/>
            }
            {
                isCreateSellerModalOpen &&
                <CreateSeller/>
            }
            {
                isCreateAdminModalOpen &&
                <CreateAdmin/>
            }
            {
                isCreateGuiderModalOpen &&
                <CreateGuider/>
            }
            {
                isCreateDriverModalOpen &&
                <CreateDriver/>
            }
            {
                passengerPlanId &&
                <PassengerPlan/>
            }
            {
                assignTripReservationId &&
                assignTripReservationId.length > 0 &&
                <AssignRservation/>
            }
            {
                traspassTripReservationId &&
                traspassTripReservationId.length > 0 &&
                <TraspassReservation/>
            }
            {
                registerPassengersTripId &&
                <ReadExcel/>
            }
            {
                registerCostsTripId &&
                <RegisterCosts/>
            }
            {
                requirementsTripId &&
                <Requirements/>
            }
            {
                accountingSellerId &&
                <Accounting/>
            }
            {
                editTripId &&
                <EditTrip/>
            }
            {
                relationshipAgencyId &&
                <AgencyRelationship/>
            }
            {
                editReservationId &&
                <EditReservation/>
            }
            {
                editPassengerData && 
                <EditPassenger/>
            }
            {
                editTourData &&
                <EditTour/>
            }
            {
                editDriverData &&
                <EditDriver/>
            }
            {
                editGuiderData &&
                <EditGuider/>
            }
            {
                editSellerData &&
                <EditSeller/>
            }
            {
                editAdminData &&
                <EditAdmin/>
            }
            {
                editAgencyData &&
                <EditAgency/>
            }
            {
                addPaymentData &&
                <AddPayment/>
            }
            {
                reservationDetails &&
                <ReservationsDetails/>
            }
            {
                viewPaymentAgencyId &&
                <ViewPayments/>
            }
            {
                editTourInfoId &&
                <EditTourInfo/>
            }
            {
                createBlogTourId &&
                <PostBlog/>
            }
            {
                isCreateZoneModalOpen &&
                <CreateZone/>
            }
            {
                editZoneId &&
                <EditZone/>
            }
            {
                isCreateSubzoneModalOpen &&
                <CreateSubzone/>
            }
            {
                editSubzoneId &&
                <EditSubzone/>
            }
            {
                groupDetails &&
                <GroupDetails/>
            }
            { listBlogsTourId &&
                <ListBlogs />
            }
            {
                editBlog?.id &&
                <EditBlog />
            }
            {
                confirmDeleteTourId &&
                <ConfirmDeleteTour />
            }
            {
                confirmDeleteAgencyId &&
                <ConfirmDeleteAgency />
            }
            {
                isCreateCarModalOpen &&
                <CreateCar />
            }
            {
                editCarData &&
                <EditCar />
            }
            {
                confirmDeleteCarId &&
                <ConfirmDeleteCar />
            }
            {
                confirmDeleteTripId &&
                <ConfirmDeleteTrip />
            }
            {
                confirmDeleteReservationId &&
                <ConfirmDeleteReservation />
            }
            {
                confirmUnassignReservationId &&
                <ConfirmUnassignReservation />
            }
            {
                editPassengerReservationId &&
                <EditPassengerReservation />
            }
            {
                createPaymentReservationId &&
                <CreatePaymentReservation />
            }
            {
                createMultiPaymentReservations && createMultiPaymentReservations.length > 0 &&
                <CreateMultiPaymentReservation />
            }
            {
                isCreateCostModalOpen &&
                <CreateCost />
            }
            {
                editCostData &&
                <EditCost />
            }
            {
                confirmDeleteCostId &&
                <ConfirmDeleteCost />
            }
            {
                reservationData &&
                <ViewReservationData />
            }
            {
                viewPaymentsData &&
                <ViewPaymentsReservation />
            }
            {
                (createPaymentResId || createPaymentGroupId) && isCreatePaymentReservationModalOpen &&
                <CreatePayment />
            }
            {
                editPaymentReservationData &&
                <EditPaymentReservation />
            }
            {
                isListDailyCostsModalOpen &&
                <ListDailyCosts />
            }
            {
                isCreateDailyCostModalOpen &&
                <CreateDailyCost />
            }
            {
                editDailyCostData &&
                <EditDailyCost />
            }
            {
                viewPaymentTraspassData &&
                <ViewPaymentsTraspass/>
            }
            {
                confirmDeletePaymentId &&
                <ConfirmDeletePayment />
            }
            {
                editPaymentData &&
                <EditPayment />
            }
            {
                confirmDeletePassengerId &&
                <ConfirmDeletePassenger />
            }
            {
                isCreateReTraspasoModalOpen &&
                <RegisterReTraspaso />
            }
            {
                createPaymentReTraspasoData &&
                <CreatePaymentReTraspaso />
            }
            {
                createRevisionData &&
                <CreateRevision />
            }
            {
                editTraspassAmountReservationId &&
                <EditTraspassAmount />
            }
            {
                isCreateCashMovementModalOpen &&
                <CreateCashMovement />
            }
            {
                editCashMovementData &&
                <EditCashMovement />
            }
            {
                confirmDeleteCashMovementId &&
                <ConfirmDeleteCashMovement />
            }
            {
                isCreatePendingPaymentModalOpen &&
                <CreatePendingPayment />
            }
            {
                editPendingPaymentData &&
                <EditPendingPayment />
            }
            {
                confirmDeletePendingPaymentId &&
                <ConfirmDeletePendingPayment />
            }
            {
                isCreateAllyModalOpen &&
                <CreateAlly/>
            }
            {
                allyInfoId &&
                <AllyInfo/>
            }
        </Main>
    )
}

const Main = styled.main`
background: url(${background});
background-size: cover;
width: 100vw;
height: 100dvh;
position: relative;
`

const Modal = styled.div`
height: 80%;
width: 90%;
max-width: 1300px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
box-shadow: 0 0 20px ${props => props.theme.blackTransparent};
background-color: ${props => props.theme.white};
display: flex;
${mobile({
    height: '100%',
    width: '100%'
})}
`

const Content = styled.div`
flex: 1;
padding: 20px;
overflow: hidden;
overflow-y: unset;
`